var map = {
	"./Cindy_Cooper.jpg": 84575,
	"./Graham_Wheeler.jpg": 92708,
	"./Laura_Flight.jpg": 6701,
	"./Mike_Bradburn.jpg": 15034,
	"./Munya_Dimairo.jpg": 57997,
	"./NIHR_logo.svg": 78713,
	"./Philip_Pallmann.jpg": 23619,
	"./Thomas_Jaki.jpg": 6303,
	"./cambridge_logo_2.png": 23444,
	"./cardiff_ctr.jpg": 11680,
	"./lancaster_uni.svg": 43918,
	"./panda-letter-logo.png": 65648,
	"./panda-logo.png": 1775,
	"./plasma.jpg": 38453,
	"./purple_coral.jpg": 44243,
	"./sheffield_ctru.png": 30506,
	"./ucl_ctc.jpg": 52994,
	"./uos-crest.svg": 25645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86190;